const normalizeName = (value) => String(value || '').trim();

export const getLocationOptions = (state, currentValue = '') => {
  const names = new Map();
  const add = (value) => {
    const name = normalizeName(value);
    if (!name) return;
    names.set(name.toLowerCase(), name);
  };

  state.locations.forEach((location) => add(location.name));
  state.characters.forEach((character) => {
    add(character.current_location);
    add(character.birth_location);
  });
  add(currentValue);

  return Array.from(names.values()).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
};

export const escapeOptionValue = (value = '') =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

export const renderLocationOptions = (options, currentValue = '', placeholder = 'Select location') => {
  const current = normalizeName(currentValue);
  return (
    `<option value="">${placeholder}</option>` +
    options
      .map((option) => {
        const safe = escapeOptionValue(option);
        const selected = option === current ? ' selected' : '';
        return `<option value="${safe}"${selected}>${safe}</option>`;
      })
      .join('')
  );
};
